import { render } from "./RedBorder.vue?vue&type=template&id=d3f582b0&scoped=true"
import script from "./RedBorder.vue?vue&type=script&lang=js"
export * from "./RedBorder.vue?vue&type=script&lang=js"

import "./RedBorder.vue?vue&type=style&index=0&id=d3f582b0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f582b0"]])

export default __exports__